import { BETA_SEARCH_SORT_OPTIONS, type BetaSearchSort } from '../utils/betaSearchSort';

/** The reader's sort control: Default (the list's own order), Recent first, More specific first. */
export function SortToggle({ selected, disabled = false, onSelect }: {
  selected: BetaSearchSort; disabled?: boolean; onSelect: (sort: BetaSearchSort) => void;
}) {
  return <div className="beta-sort-toggle" role="group" aria-label="Sort order">{BETA_SEARCH_SORT_OPTIONS.map(option =>
    <button key={option.label} type="button" className={selected === option.value ? 'active' : ''} aria-pressed={selected === option.value}
      disabled={disabled} onClick={() => onSelect(option.value)}>{option.label}</button>)}</div>;
}
